module.exports = " <div class=block> <div class=block__header> <h2 class=block__title>{{title}}</h2> </div> <div class=block__content> <ul class=basket-list> <basket-list-item v-for=\"item in content.Items\" :content=item></basket-list-item> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/basket/BasketList.vue
// module id = 180
// module chunks = 0